<!-- market-intelligence-report.component.html -->
<div class="h-screen overflow-y-auto">

  <!-- Hero Section -->
  <section class="bg-secondary-900 flex items-center justify-center px-4 sm:px-6 lg:px-8 relative">

    <div class="max-w-4xl w-full text-center py-16">
      <!-- Logo -->
      <div class="mb-12">
        <img src="/assets/logo-white.svg" alt="SalesOMMO" class="h-12 w-auto mx-auto">
      </div>

      <!-- Main Content -->
      <div class="text-white">
        <h1 class="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6">
          Get your <span class="text-orange-500">market <br /> intelligence</span> report
        </h1>

        <p class="text-xl sm:text-2xl font-light leading-relaxed mb-8 opacity-95 max-w-3xl mx-auto">
          See where you stand, who you're competing against, <br /> and what actions to take next.
        </p>

        <p class="text-2xl text-orange-500 font-medium mb-12">
          Free. No credit card. No calls.
        </p>

        <!-- Benefits -->
        <div class="flex justify-center gap-4 mx-auto mb-12 text-center">
          <div>
            <div class="flex items-start gap-3 text-lg">
              <svg class="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.6667 5L7.50001 14.1667L3.33334 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="opacity-90">Created just for you, based on your exact market</span>
            </div>
            <div class="flex items-start gap-3 text-lg">
              <svg class="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.6667 5L7.50001 14.1667L3.33334 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="opacity-90">Focused on your industry, using real, verified data</span>
            </div>
          </div>
        </div>

        <!-- CTA Button -->
        <div>
          <button class="bg-orange-500 hover:opacity-90 text-white font-semibold text-xl px-10 py-4 rounded-lg">
            Get your report
          </button>
          <p class="mt-4 text-sm opacity-80">
            No credit card required. Delivered in your account.
          </p>
        </div>
      </div>

    </div>
  </section>

  <!-- Trusted By Section -->
  <section class="bg-gray-50 py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-3xl md:text-4xl font-bold text-center text-secondary-900 mb-12">
        Trusted by sales teams at...
      </h2>

      <!-- Company Logos Grid -->
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center">
        <!-- Placeholder for PROCESIO -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 1</span>
        </div>

        <!-- Placeholder for Veridion -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 2</span>
        </div>

        <!-- Placeholder for milk & cookies -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 3</span>
        </div>

        <!-- Placeholder for XCODES -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 4</span>
        </div>

        <!-- Placeholder for FieldOS -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 5</span>
        </div>

        <!-- Placeholder for Hermix -->
        <div class="w-32 h-12 bg-gray-200 rounded flex items-center justify-center">
          <span class="text-gray-500 text-sm">Logo 6</span>
        </div>
      </div>
    </div>
  </section>

  <!-- What You'll Get Inside Section -->
  <section class="bg-white py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
          What you'll get inside
        </h2>
        <p class="text-xl text-gray-600">
          A fast, clear snapshot of your market, including:
        </p>
      </div>

      <div class="grid lg:grid-cols-2 gap-12 items-center">
        <!-- Left Column - Feature List -->
        <div class="space-y-6">
          <!-- Feature 1 -->
          <div class="flex items-start gap-4">
            <svg class="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p class="text-lg text-gray-700">
              Total number of companies in your segment
            </p>
          </div>

          <!-- Feature 2 -->
          <div class="flex items-start gap-4">
            <svg class="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p class="text-lg text-gray-700">
              Breakdown by team size, founding year, and country
            </p>
          </div>

          <!-- Feature 3 -->
          <div class="flex items-start gap-4">
            <svg class="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p class="text-lg text-gray-700">
              Top keywords and positioning tags used across your market
            </p>
          </div>

          <!-- Feature 4 -->
          <div class="flex items-start gap-4">
            <svg class="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p class="text-lg text-gray-700">
              A list of real companies matching your filters
            </p>
          </div>

          <!-- Feature 5 -->
          <div class="flex items-start gap-4">
            <svg class="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p class="text-lg text-gray-700">
              A short summary with suggested next steps
            </p>
          </div>
        </div>

        <!-- Right Column - Image -->
        <div class="relative">
          <div class="rounded-lg overflow-hidden">
            <!-- Placeholder for tablet/analytics image -->
            <div class="bg-gray-200 h-96 flex items-center justify-center">
              <span class="text-gray-500 text-lg">Analytics Image Placeholder</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- How It Works Section -->
  <section class="bg-gray-50 py-20">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-8">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900 mb-6">
          How it works
        </h2>
        <p class="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
          It's simple, fast, and designed to give you real market insights without wasting your time. Each report is powered by real business data from over 100 million companies, analyzed across 70+ attributes.
        </p>
      </div>

      <!-- Three Steps -->
      <div class="grid md:grid-cols-3 gap-8 mt-16 mb-16">
        <!-- Step 1 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"></path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-secondary-900 mb-3">
            Create a free account
          </h3>
          <p class="text-gray-600">
            Takes less than a minute. No credit card. No hidden steps.
          </p>
        </div>

        <!-- Step 2 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-secondary-900 mb-3">
            Request your industry
          </h3>
          <p class="text-gray-600">
            We'll build your report based on real data from your exact segment.
          </p>
        </div>

        <!-- Step 3 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-secondary-900 mb-3">
            Check your account and inbox
          </h3>
          <p class="text-gray-600">
            You'll get a tailored snapshot instantly.
          </p>
        </div>
      </div>

      <!-- CTA Button -->
      <div class="text-center">
        <button class="bg-orange-500 hover:opacity-90 text-white font-semibold text-xl px-10 py-4 rounded-lg">
          Get your report
        </button>
        <p class="mt-6 text-gray-600">
          No spam. We hate it as much as you do.
        </p>
      </div>
    </div>
  </section>

  <!-- This is for you if... Section -->
  <section class="bg-white py-20">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900">
          This is for you if...
        </h2>
      </div>

      <!-- Four Cards Grid -->
      <div class="grid md:grid-cols-2 gap-8">
        <!-- Card 1 - Founder -->
        <div class="bg-blue-50 p-8 rounded-lg">
          <div class="flex items-start gap-4">
            <div class="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"></path>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-secondary-900 mb-3">
                You're a founder
              </h3>
              <p class="text-gray-600">
                and you need to understand your market before wasting time on the wrong accounts.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 2 - Sales Leader -->
        <div class="bg-blue-50 p-8 rounded-lg">
          <div class="flex items-start gap-4">
            <div class="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"></path>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-secondary-900 mb-3">
                You're a sales leader
              </h3>
              <p class="text-gray-600">
                and you need to sharpen your team's targeting and land more relevant conversations.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 3 - Growth Team -->
        <div class="bg-blue-50 p-8 rounded-lg">
          <div class="flex items-start gap-4">
            <div class="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-secondary-900 mb-3">
                You're part of a growth team
              </h3>
              <p class="text-gray-600">
                and you need data to map the competition and find whitespace you can win.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 4 - Lead Gen Agency -->
        <div class="bg-blue-50 p-8 rounded-lg">
          <div class="flex items-start gap-4">
            <div class="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"></path>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-secondary-900 mb-3">
                You run a lead gen agency
              </h3>
              <p class="text-gray-600">
                and you need accurate industry context to build stronger, better-targeted campaigns.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Why it's free Section -->
  <section class="bg-secondary-900 py-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-8">
        Why it's free
      </h2>

      <p class="text-xl text-white/90 mb-8">
        You don't need a credit card, and no one's going to chase you with a sales call.<br>
        That's not how we work.
      </p>

      <p class="text-lg text-white/80 leading-relaxed mb-12">
        We're offering this for free because we believe real growth starts with clarity. And when more people have access to better data, everyone sells better, faster, and simpler. This is our way of giving you that edge, upfront.
      </p>

      <!-- CTA Button -->
      <div class="mb-8">
        <button class="bg-orange-500 hover:opacity-90 text-white font-semibold text-xl px-10 py-4 rounded-lg">
          Get your report
        </button>
      </div>

      <p class="text-white/70">
        No spam. We hate it as much as you do.
      </p>
    </div>
  </section>

  <!-- How we personalize it Section -->
  <section class="bg-white py-20">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-secondary-900 mb-6">
        How we personalize it
      </h2>

      <p class="text-xl text-gray-600 mb-8">
        Each report is fully tailored to your specific industry, segment, and region.
      </p>

      <div class="max-w-4xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed">
        <p>
          We don't send generic templates. We pull real company data that matches your space, surface the most relevant keywords and business tags, and adjust the recommendations based on who you're selling to and where.
        </p>

        <p>
          Whether you're targeting mid-size B2B SaaS in Europe or logistics companies in the US, the market intelligence report is built around your actual market context.
        </p>
      </div>
    </div>
  </section>

  <!-- Outcomes you can act on Section -->
  <section class="bg-blue-50 py-20">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900 mb-8">
          Outcomes you can act on
        </h2>

        <p class="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
          We pride ourselves on the fact that this is not just a report you get and forget somewhere in a folder. It is built to help you and to be used as the foundation for your journey towards better sales.
        </p>
      </div>

      <!-- Five Outcomes Grid -->
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16 justify-items-center">
        <!-- Outcome 1 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <p class="text-gray-700 leading-relaxed">
            Target smarter by seeing who's actually in your space and worth pursuing
          </p>
        </div>

        <!-- Outcome 2 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <p class="text-gray-700 leading-relaxed">
            Prioritize faster with breakdowns by size, geography, and maturity
          </p>
        </div>

        <!-- Outcome 3 -->
        <div class="text-center">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <p class="text-gray-700 leading-relaxed">
            Craft sharper messages using the real tags and keywords companies use to position themselves
          </p>
        </div>

        <!-- Outcome 4 -->
        <div class="text-center lg:col-start-1 lg:col-end-2 lg:ml-auto lg:mr-4">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"></path>
            </svg>
          </div>
          <p class="text-gray-700 leading-relaxed">
            Plan your next move with suggested actions based on your market's structure
          </p>
        </div>

        <!-- Outcome 5 -->
        <div class="text-center lg:col-start-3 lg:col-end-4 lg:ml-4 lg:mr-auto">
          <div class="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <p class="text-gray-700 leading-relaxed">
            Back your strategy with data when you're pitching, planning, or building campaigns
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Customer Testimonials Section -->
  <section class="bg-white py-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900">
          Customer Testimonials
        </h2>
      </div>

      <!-- Testimonial Card -->
      <div class="bg-gray-50 rounded-lg p-12 text-center">
        <!-- Customer Avatar -->
        <div class="mb-8">
          <div class="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full mx-auto flex items-center justify-center">
            <span class="text-white font-semibold text-xl">
              {{ currentTestimonial.name.charAt(0) }}{{ currentTestimonial.name.split(' ')[1]?.charAt(0) }}
            </span>
          </div>
        </div>

        <!-- Testimonial Content -->
        <blockquote class="text-xl text-gray-700 italic mb-8 leading-relaxed">
          "{{ currentTestimonial.quote }}"
        </blockquote>

        <!-- Customer Info -->
        <div class="text-center">
          <p class="font-semibold text-secondary-900 text-lg">{{ currentTestimonial.name }}</p>
          <p class="text-gray-600">{{ currentTestimonial.title }}, {{ currentTestimonial.company }}</p>
        </div>
      </div>

      <!-- Carousel Indicators -->
      <div class="flex justify-center mt-8 space-x-3">
        <button
          *ngFor="let testimonial of testimonials; let i = index"
          (click)="selectTestimonial(i)"
          class="w-3 h-3 rounded-full transition-colors duration-300 focus:outline-none"
          [class.bg-orange-500]="i === currentTestimonialIndex"
          [class.bg-gray-300]="i !== currentTestimonialIndex"
          [attr.aria-label]="'View testimonial ' + (i + 1)">
        </button>
      </div>

      <!-- CTA Section -->
      <div class="text-center mt-16">
        <button class="bg-orange-500 hover:opacity-90 text-white font-semibold text-xl px-10 py-4 rounded-lg mb-4">
          Get your report
        </button>
        <p class="text-gray-600">
          No spam. We hate it as much as you do.
        </p>
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="bg-blue-50 py-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-secondary-900">
          FAQ
        </h2>
      </div>

      <!-- FAQ Items -->
      <div class="space-y-4">
        <!-- FAQ Item 1 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(0)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[0]">
            <span class="text-lg font-semibold text-secondary-900">Who can request a report?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[0]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[0]">
            <p>Anyone with a free SalesOMMO account. No approvals, no filters. If you sign up, you get one.</p>
          </div>
        </div>

        <!-- FAQ Item 2 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(1)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[1]">
            <span class="text-lg font-semibold text-secondary-900">What industries are covered?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[1]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[1]">
            <p>We cover all major industries including SaaS, technology, healthcare, finance, e-commerce, manufacturing, and more. Our database spans over 100 million companies across 70+ attributes.</p>
          </div>
        </div>

        <!-- FAQ Item 3 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(2)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[2]">
            <span class="text-lg font-semibold text-secondary-900">How fast will I get the report?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[2]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[2]">
            <p>Most reports are generated and delivered within 24-48 hours of your request. You'll receive an email notification when your personalized market intelligence report is ready in your account.</p>
          </div>
        </div>

        <!-- FAQ Item 4 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(3)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[3]">
            <span class="text-lg font-semibold text-secondary-900">How accurate is the data?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[3]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[3]">
            <p>Our data is sourced from verified business databases and is regularly updated. We use multiple data sources and validation processes to ensure accuracy, with data refreshed monthly to maintain relevance.</p>
          </div>
        </div>

        <!-- FAQ Item 5 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(4)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[4]">
            <span class="text-lg font-semibold text-secondary-900">Can I request multiple reports?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[4]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[4]">
            <p>Yes, you can request multiple reports for different industries, regions, or market segments. Each report is tailored specifically to your parameters and market focus.</p>
          </div>
        </div>

        <!-- FAQ Item 6 -->
        <div class="bg-white rounded-lg border border-gray-200">
          <button
            (click)="toggleFAQ(5)"
            class="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
            [attr.aria-expanded]="openFAQs[5]">
            <span class="text-lg font-semibold text-secondary-900">What if I need help reading the report?</span>
            <svg
              class="w-5 h-5 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="openFAQs[5]"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            class="px-6 pb-4 text-gray-600"
            [class.hidden]="!openFAQs[5]">
            <p>Each report comes with clear explanations and suggested next steps. If you need additional guidance, our support team is available to help you interpret the findings and recommendations.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Final CTA Section -->
  <section class="bg-secondary-900 py-20">
    <div class="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
          Want to see what your market actually looks like?
        </h2>
        <p class="text-xl text-white/90">
          Get your free report based on real business data.
        </p>
      </div>

      <!-- Form -->
      <form [formGroup]="leadMagnetForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <!-- Email Field -->
        <div>
          <label for="email" class="block text-white font-medium mb-2">
            Email <span class="text-red-400">*</span>
          </label>
          <input
            type="email"
            id="email"
            formControlName="email"
            placeholder="What is your email?"
            class="w-full px-4 py-3 text-gray-900 bg-white rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent placeholder-gray-400"
            [class.border-red-500]="leadMagnetForm.get('email')?.invalid && leadMagnetForm.get('email')?.touched">
          <p class="mt-2 text-sm text-white/70">
            We'll use your email only to share important information and create your account.
          </p>
          <p *ngIf="leadMagnetForm.get('email')?.invalid && leadMagnetForm.get('email')?.touched" class="mt-1 text-sm text-red-400">
            <span *ngIf="leadMagnetForm.get('email')?.errors?.['required']">Email is required.</span>
            <span *ngIf="leadMagnetForm.get('email')?.errors?.['email']">Please enter a valid email address.</span>
          </p>
        </div>

        <!-- LinkedIn URL Field -->
        <div>
          <label for="linkedin_url" class="block text-white font-medium mb-2">
            LinkedIn URL <span class="text-red-400">*</span>
          </label>
          <input
            type="url"
            id="linkedin_url"
            formControlName="linkedin_url"
            placeholder="https://www.linkedin.com/in/yourprofile"
            class="w-full px-4 py-3 text-gray-900 bg-white rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent placeholder-gray-400"
            [class.border-red-500]="leadMagnetForm.get('linkedin_url')?.invalid && leadMagnetForm.get('linkedin_url')?.touched">
          <p class="mt-2 text-sm text-white/70">
            This helps us understand your professional background and industry.
          </p>
          <p *ngIf="leadMagnetForm.get('linkedin_url')?.invalid && leadMagnetForm.get('linkedin_url')?.touched" class="mt-1 text-sm text-red-400">
            <span *ngIf="leadMagnetForm.get('linkedin_url')?.errors?.['required']">LinkedIn URL is required.</span>
            <span *ngIf="leadMagnetForm.get('linkedin_url')?.errors?.['pattern']">Please enter a valid LinkedIn profile URL.</span>
          </p>
        </div>

        <!-- Error Message -->
        <ng-container *ngIf="error$ | async as error">
          <div *ngIf="!(response$ | async)" class="bg-red-500 bg-opacity-20 border border-red-500 text-white px-4 py-3 rounded-lg">
            <p class="font-medium">Registration failed</p>
            <p class="text-sm mt-1">{{ error?.error?.message || error?.message || 'An error occurred. Please try again.' }}</p>
          </div>
        </ng-container>

        <!-- Success Message -->
        <ng-container *ngIf="response$ | async as response">
          <div *ngIf="!(loading$ | async)" class="bg-green-500 bg-opacity-20 border border-green-500 text-white px-4 py-3 rounded-lg">
            <p class="font-medium">Success!</p>
            <p class="text-sm mt-1">{{ response.message || 'Your market intelligence report is being generated. Check your email and account dashboard.' }}</p>
          </div>
        </ng-container>

        <!-- Submit Button -->
        <div class="pt-4">
          <button
            type="submit"
            [disabled]="(loading$ | async)"
            class="w-full bg-orange-500 hover:opacity-90 text-white font-semibold text-xl px-10 py-4 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">
            <span *ngIf="!(loading$ | async)">Get your report</span>
            <span *ngIf="loading$ | async">Processing...</span>
          </button>
        </div>
      </form>
    </div>
  </section>

</div>
